<template>
  <validation-observer ref="step1">
    <b-form>
      <b-row>
        <b-col md="4">
          <b-form-group label="Campaign Name" label-for="campaign_name">
            <validation-provider rules="required" #default="{ errors }" name="campaign name" vid="Campaign Name">
              <b-form-input v-model="campaignId.name" placeholder="Campaign Name" name="campaign_name"
                :state="errors.length > 0 ? false : null" />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Budget" label-for="budget">
            <validation-provider rules="required" #default="{ errors }" name="Budget" vid="Budget">
              <b-form-input v-model="campaignId.budget" placeholder="Budget" name="budget" type="number"
                :state="errors.length > 0 ? false : null" />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- <b-col md="4">
          <b-form-group label="Planned Budget" label-for="plannedBudget">
            <validation-provider rules="required" #default="{ errors }" name="PlannedBudget" vid="PlannedBudget">
              <b-form-input v-model="campaignId.plannedBudget" placeholder="Planned Budget" name="plannedBudget"
                type="number" :state="errors.length > 0 ? false : null" />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->
        <b-col md="4">
          <b-form-group label="Status" label-for="status">
            <validation-provider rules="required" #default="{ errors }" name="Status" vid="Status">
              <b-form-select v-model="campaignId.status" :state="errors.length > 0 ? false : null"
                :options="statusOptions" />

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group label="Start Date" label-for="start_date">
            <validation-provider rules="required" #default="{ errors }" name="start date" vid="Start Date">
              <b-form-datepicker v-model="campaignId.startDate" id="start_date" placeholder="Choose a date" local="en"
                :state="errors.length > 0 ? false : null" :initial-date="new Date()" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="End Date" label-for="end_date">
            <validation-provider rules="required" #default="{ errors }" name="end date" vid="End Date">
              <b-form-datepicker v-model="campaignId.endDate" id="end_date" placeholder="Choose a date" local="en"
                :state="errors.length > 0 ? false : null" :initial-date="startDate" :min="startDate" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12" class="d-flex justify-content-end">
          <b-button variant="primary" @click="updateCampaign">Submit</b-button>
        </b-col>

      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BFormFile,
  BFormRadio,
  BMedia,
  BMediaAside,
  BMediaBody,
  BLink,
  BCardText,
  BFormCheckbox,
  BCard,
  BTabs,
  BTab,
  BCardFooter
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import flatPickr from "vue-flatpickr-component";
import { required, email } from "@validations";
import {
  getProviderName,
  createProvider,
  deleteProvider,
  getProviders,
  testsmtp,
  updateProvider,
} from "@/store/smtp/services";
import { FormWizard, TabContent } from "vue-form-wizard";
import { quillEditor } from "vue-quill-editor";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import CampaignDetails from './CampaignDetails.vue';
export default {
  name: "AddCampaign",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BFormRadio,
    vSelect,
    quillEditor,
    flatPickr,
    BMedia,
    BMediaAside,
    BMediaBody,
    BLink,
    BCardText,
    BFormCheckbox,
    BCard,
    BTabs,
    BTab,
    FormWizard,
    TabContent, CampaignDetails,
    BCardFooter
  },
  data() {
    return {
      id: this.$route.params.id,
      mainLoading: false,
      imageFiles: [],
      imagePreviews: [],
      emailtemplatelist: [],
      selectedProvider: null,
      selectedTemplateId: null,
      selectedTemplate: [],
      Selected: "A",
      smtp: [],
      Selected1: "c",
      SelectedRadio: "D", // Default to "Save as Draft"
      //dateNtim: null,
      selected: [{ title: "Segment 1" }, { title: "Segment 2" }],
      content: "",
      name: "",
      budget: null,
      plannedBudget: null,
      startDate: null,
      endDate: null,
      scheduledPublishedDate: null,
      subject: "",
      file: null,
      selectedSegments: [],
      segmentOptions: [],
      required,
      linkedinChecked: false,
      facebookChecked: false,
      instagramChecked: false,
      isSwitchChecked: false,
      facebookContent: "",
      instagramContent: "",
      linkedinContent: "",
      statusOptions: [
        { value: "DRAFT", text: "DRAFT" },
        { value: "INPROGRESS", text: "IN PROGRESS" },
        { value: "COMPLETED", text: "COMPLETED" },
        { value: "CANCELLED", text: "CANCELLED" }
      ]
    };
  },

  computed: {
    ...mapGetters("emailtemplate", {
      emailtemplate: "emailtemplate",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    ...mapGetters("emailcampaign", {
      emailcampaign: "emailcampaign",
      loading: "loading",
    }),
    ...mapGetters("marketingModule", {
      appid: "appid",
      campaignId: "campaignId",
      posts: "drafts",
      loadingMarketing: "loading",
    }),
    showSaveDraft() {
      return this.SelectedRadio === "D";
    },
    showSaveScheduled() {
      return this.SelectedRadio === "B";
    },
    showSendNow() {
      return this.SelectedRadio === "A";
    },
    today() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  methods: {
    ...mapActions("segmentModule", ["getSegmentsAction"]),
    ...mapActions("emailtemplate", ["getEmailTemplateListAction"]),
    ...mapActions("emailcampaign", ["addEmailCampaignAction"]),
    ...mapActions("marketingModule", [
      "getAppIdAction",
      "getPostAction",
      "removePostAction",
      "postMarketingCampaignAction",
      "getMarketingCampaignByIDAction",
      "putMarketingCampaignAction",
      "getCampaignDraftByIDAction", "getCampaignDraftListAction"
    ]),
    async updateCampaign() {
      const isValid = await this.$refs.step1.validate();  // Validate the form

      if (!isValid) {
        this.$swal({
          title: "Validation Error",
          text: "Please fill in all required fields.",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
        return;
      }

      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the campaign is being updated",
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      const payload = {
        campaignId: this.id,
        name: this.campaignId.name,
        startDate: this.campaignId.startDate,
        endDate: this.campaignId.endDate,
        budget: this.campaignId.budget,
        plannedBudget: this.campaignId.plannedBudget,
        status: this.campaignId.status,
        description: "-",
      };

      try {
        await this.putMarketingCampaignAction(payload);
        loader.close();

        this.$swal({
          title: "Success",
          text: "Campaign updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });

        // Navigate to campaign list or refresh data
        this.$router.push({ name: "marketing-campaign-list" });

      } catch (error) {
        console.error("Error updating campaign:", error);
        loader.close();

        this.$swal({
          title: "Error",
          text: "Failed to update campaign. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    },
    showImagePreview(event) {
      this.imageFiles = [...event.target.files];
      this.imagePreviews = [];

      for (let file of this.imageFiles) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.imagePreviews.push(e.target.result);
        };

        reader.readAsDataURL(file);
      }
    },
    selectTemplate() {
      this.selectedTemplate = this.emailtemplate.find(
        (template) => template.templateId === this.selectedTemplateId
      );
    },

    errordateNtime() {
      this.$swal({
        title: "Error!",
        text: " Please select a date!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async formSubmitted(status) {
      console.log("statussss", status);
      if (status !== "DRAFT") {
        const isValid = await this.$refs.formAddCampaign.validate();
        if (!isValid) {
          // Handle invalid form
          return;
        }
      }

      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the Campaign is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      const payload = {
        campaignId: this.id,
        name: this.campaignId.name,
        startDate: this.campaignId.startDate,
        endDate: this.campaignId.endDate,
        budget: this.campaignId.budget,
        plannedBudget: this.campaignId.plannedBudget,
        description: this.campaignId.description,
        subject: this.campaignId.name,
        status: status,
        templateId: this.selectedTemplateId,
        segmentId: this.selectedSegments.map((segment) => segment.value),
        campaignDrafts: [
          {
            content: this.campaignId.description,
            scheduledPublishedDate:
              status === "SCHEDULED"
                ? this.campaignId.scheduledPublishedDate
                : null,
            segmentId: this.selectedSegments.map((segment) => segment.value),
          },
        ],
        smtpSettingId: this.selectedProvider,
      };

      await this.putMarketingCampaignAction(payload)
        .then((response) => {
          loader.close();
          if (status === "SCHEDULED") {
            this.success(
              `Marketing Campaign successfully scheduled for ${this.campaignId.scheduledPublishedDate}!`
            );
          } else {
            this.success("Marketing Campaign Updated!");
          }

          this.$router.push({ name: "marketing-campaign-list" });
        })
        .catch((ex) => {
          loader.close();
          this.error(ex.response.data);
        });
    },

    saveDraft() {
      this.formSubmitted("DRAFT");
    },
    success(message) {
      this.$swal({
        title: "Marketing Campaign Added!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },

    saveScheduled() {
      //console.log("checked", this.facebookChecked);
      console.log("dateeeeeeeeeeeee");
      if (this.campaignId.scheduledPublishedDate === null) {
        this.errordateNtime();
        return;
      }

      if (this.SelectedRadio === "B" && this.campaignId.scheduledPublishedDate) {
        this.formSubmitted("SCHEDULED");
      } else {
        this.formSubmitted("DRAFT");
      }
    },

    sendNow() {
      if (this.SelectedRadio === "A") {
        this.formSubmitted("COMPLETED");
      }
    },

    async getSMPT() {
      try {
        const response = await getProviders();
        this.smtp = response.data.result.map((smtp) => ({
          value: smtp.id,
          text: `${smtp.provider}`,
        }));
      } catch (error) {
        console.log(error);
      }
    },
  },

  async mounted() {
    this.facebookToken = this.$route.query.access_token;
    this.mainLoading = true;
    try {
      await this.getMarketingCampaignByIDAction(this.id);

      await this.getEmailTemplateListAction().then(() => {
        this.emailtemplatelist = this.emailtemplate.map((template) => ({
          value: template.templateId,
          text: `${template.name}`,
        }));
      });

      await this.getSMPT();

      await this.getSegmentsAction().then(() => {
        this.segmentOptions = this.segments.map((segment) => ({
          value: segment.segmentId,
          itemTitle: `${segment.name}`,
        }));
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.mainLoading = false;
    }
  },
  watch: {
    startDate(newDate) {
      if (
        newDate &&
        this.endDate &&
        new Date(this.endDate) < new Date(newDate)
      ) {
        this.endDate = null; // Clear endDate if it is earlier than startDate
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
@import "@core/scss/vue/libs/vue-wizard.scss";
</style>
